
import { Avatar, Card, List, Space, Typography, Image } from "antd";
// Components
import { ButtonLink } from "../../../../../../../../components";
import { RemarkTextArea } from '../../components'

// Styles
import classStyles from "../../index.module.css";

const { Text } = Typography;

const RemarkLists = ({
  dataSource,
  setIndex,
  setEdit,
  setValue,
  setShowEditTextArea,
  setShowTextArea,
  setRecord,
  showEditTextArea,
  value,
  edit,
  index,
  messageApi,
  handleOkButton,
  deleteRemarkHDLR,
  TIME,
  loading,
  user
}) => {

  const sortedData = dataSource.sort(
    (a, b) => (a?.ref_status ? 1 : -1) - (b?.ref_status ? 1 : -1)
  );

  return (
    <List
      loading={loading}
      itemLayout="horizontal"
      dataSource={sortedData}
      renderItem={(cel, i) => {
        const { createdAt, createdBy, createdBy_name } = cel;

        const Title = () => {
          return (
            <div>
                <div className={classStyles["list-header"]}>
                  <Space>
                    <Avatar
                      style={{ backgroundColor: '#292C33' }}
                    >
                      <Text style={{ fontSize: '1rem', color: '#DDD' }}>{createdBy_name ? createdBy_name.trim().charAt(0).toUpperCase() : 'A'}</Text>
                    </Avatar>
                    <div>
                      <span>{createdBy_name}/ {createdBy}</span>
                      <p style={{ fontWeight: "300", color: "#878787" }}>
                        Commented at {TIME.parseTime(createdAt)}
                      </p>
                    </div>
                  </Space>
                </div>
            </div>
          );
        };

        const Description = () => {
          const getRelevantAttachment = (cel) => {
            const attachments = cel?.attachment;
            if (!attachments || attachments.length === 0) {
              return null; // or handle no attachments case
            }
            const attachmentCount = attachments.length;
            if (attachmentCount === 1) {
              return attachments[0];
            }
            // When there are more than one attachment
            return attachments[attachmentCount - 2];
          };

          const excelFile = getRelevantAttachment(cel);

          const handleButtonClick = () => {
            window.open(excelFile?.url, "_blank");
          };
 
          return (
              <div>
                <Card className={classStyles["card-remark"]}>
                  {cel?.comment} <br /> <br />
                  {cel?.photos && cel.photos.length > 0 && (
                    <Image.PreviewGroup items={cel.photos}>
                      {cel.photos.map((photo, index) => (
                        <Image
                          key={index}
                          width={150}
                          height={150}
                          src={photo}
                          style={{ marginRight: 8, marginBottom: 8 }}
                        />
                      ))}
                    </Image.PreviewGroup>
                  )}


                  <ButtonLink onClick={handleButtonClick}>
                    {excelFile?.name}
                  </ButtonLink>
                </Card>

                <div>
                  <div style={{ display: "inline-flex" }}>
                    <ButtonLink
                      onClick={() => {
                        setIndex(i);
                        setEdit(true);
                        setShowEditTextArea(true);
                        setShowTextArea(false)
                        setValue({ comment: cel?.comment, url: cel?.photos });
                        setRecord(cel);
                      }}
                    >
                      Edit
                    </ButtonLink>
                    <span style={{ marginRight: "8px" }}>|</span>
                    <ButtonLink
                      onClick={() => {
                        messageApi.open({
                          type: "loading",
                          content: "Deleting remark...",
                          duration: 0,
                        });
                        deleteRemarkHDLR(
                        {
                          uid: user.uid,
                          comment: {...cel}
                        },
                        () =>  messageApi.destroy());
                      }}
                    >
                      Delete
                    </ButtonLink>
                  </div>
                </div>
              </div>
          );
        };

        return (
          <>
          {showEditTextArea && edit && index === i ? (
              <RemarkTextArea
                value={value}
                setValue={setValue}
                handleOkButton={handleOkButton}
                setShowEditTextArea={setShowEditTextArea}
                setShowTextArea={setShowTextArea}
                edit={edit}
              />
            ) : (
              <List.Item style={{ padding: "30px 0" }}>
                <List.Item.Meta
                  title={<Title />}
                  description={<Description />}
                />
              </List.Item>
          )}
          </>
        );
      }}
    />
  );
};

export default RemarkLists;
